module.exports = __webpack_public_path__ + "img/EU Logo quer.7f8b3ff3.svg";